import { useQuery } from '@tanstack/react-query';
import { useTRPC } from '../trpc.js';
import type { EnrichmentStatus } from './types.js';

/** While the drawer is open, or a job is running, the page asks again this often. */
const POLL_MS = 10_000;

export interface Enrichment {
  status: EnrichmentStatus | undefined;
}

/**
 * One `enrichment.status` query behind both the toolbar's dot and the drawer's
 * three cards, so opening the drawer does not start a second poll of the same
 * facts. It always fetches once, so the dot is right the moment the page
 * loads; it only keeps re-asking while there is a reason to: the drawer is
 * open, or a job it would report on is still running.
 */
export function useEnrichment(drawerOpen: boolean): Enrichment {
  const trpc = useTRPC();

  const status = useQuery(
    trpc.enrichment.status.queryOptions(undefined, {
      refetchInterval: (query) =>
        drawerOpen || query.state.data?.running === true ? POLL_MS : false,
    }),
  );

  return { status: status.data };
}
